/**
 * @fileoverview 简单的Tab切换管理
 * @author 陈立英
 */
define(function(require, exports, module) {
    const Base = require('c-base');
    const IScroll = require('../iscroll');
    const SingleTabView = Base.extend({
        defaults: {
            wrap: '#J-Tabs',
            index: -1,
            tabs: '[node-id="tab"]',
            panels: '[node-id="panel"]',
            scrollWrap: '[node-id="scrollWrap"]',
            scroll: '[node-id="scroll"]',
            prev: '[node-id="prev"]',
            next: '[node-id="next"]',
            selectedIndex: 0,
            selectedClass: 'selected',
            event: 'click',
            scrollable: false,
            direction: 'left' // 显示方向 left： right
        },

        initialize: function() {
            let self = this;
            self.Parent.apply(self, arguments);
        },

        render: function() {
            this.buildDOM();
            this.bindEvent();
            this.isInit = true;
            this.syncUI();
        },
        buildDOM: function() {
            this.tabs && this.tabs.off();
            this.nodeWrap = $(this.get("wrap")) || $('body');
            this.nodeScrollWrap = $(this.get("scrollWrap"), this.nodeWrap);
            this.tabs = $(this.get("tabs"), this.nodeWrap);
            this.panels = $(this.get("panels"), this.nodeWrap);
            this.nodePrev = $(this.get("prev"), this.nodeWrap);
            this.nodeNext = $(this.get("next"), this.nodeWrap);
            this.tabLength = this.tabs.length;

            this.event = this.get('event');
            this.selectedClass = this.get('selectedClass');
            this.direction = this.get('direction');

            if(this.get('scrollable')){
                this.itemWH = Math.ceil(this.nodeWrap.find('li').css('width').replace('px', ''));

                this.syncUI(null,false);
                //this.tabWrapWH = this.itemWH * this.tabLength;
                this.tabWrapWH = this.getTabWidth();
                this.maxScrollWidth = this.tabWrapWH - this.nodeScrollWrap.width();
                this.nodeNavScroll = $(this.get('scroll'), this.nodeWrap);

                this.nodeNavScroll.css({
                    width: this.tabWrapWH
                });

                if (this.direction == 'right') {
                    this.startX = -(this.tabWrapWH - $('body').width());

                    this.iscroll = new IScroll(this.nodeScrollWrap[0], {
                        eventPassthrough: true,
                        scrollX: true,
                        scrollY: false,
                        preventDefault: false,
                        startX: this.startX
                    });
                } else {
                    this.iscroll = new IScroll(this.nodeScrollWrap[0], {
                        eventPassthrough: true,
                        scrollX: true,
                        scrollY: false,
                        preventDefault: false
                    });
                }

                this.offset = 0;
            }
        },

        getTabWidth(){
            let width = 0;
            this.nodeScrollWrap.find('li').each((index,item)=>{
                width += Math.ceil($(item).css('width').replace('px', ''));
            });
            return width;
        },

        // 默认选中的Tab展示
        syncUI: function(index,emit=true) {
            let selected = this.get("selectedIndex");
            if (typeof index == "number") {
                this.select(index,emit);
            } else if (typeof selected == "number") {
                this.select(selected,emit);
            }
        },

        bindEvent: function() {
            let self = this;

            this.tabs.on(this.event, function(e) {
                self._onTabClick(e);
            });

            this.on('select', function(e) {
                self.set('index', e.index);
            });

            if (this.nodePrev) {
                this.nodePrev.on('click', function(e) {
                    self._handlePrev();
                });
            }

            if (this.nodeNext) {
                this.nodeNext.on('click', function(e) {
                    self._handleNext();
                });
            }
        },

        _handlePrev: function() {
            let index = this.get('index');
            let nodePrev = this.nodePrev;

            if (index == 0) {
                return;
            }
            this.select(index - 1);
        },

        _handleNext: function() {
            let index = this.get('index');

            if (index == this.tabLength - 1) {
                return;
            }
            this.select(index + 1);
        },

        _onTabClick: function(e) {
            let index = this.tabs.indexOf(e.currentTarget);

            if (index !== this.get('index')) {
                this.select(index);
            }
        },

        select: function(index,emit=true) {
            let val = index,
                prev = this.get("index");
            let selectedClass = this.selectedClass;
            let nodePrev = this.nodePrev;
            let nodeNext = this.nodeNext;

            let tab = val > -1 ? this.tabs.eq(val) : null,
                prevTab = prev > -1 ? this.tabs.eq(prev) : null;

            let panel = val > -1 ? this.panels.eq(val) : null,
                prevPanel = prev > -1 ? this.panels.eq(prev) : null;

            prevTab && prevTab.removeClass(selectedClass);
            tab && tab.addClass(selectedClass);
            prevPanel && prevPanel.css({ display: 'none' });
            panel && panel.css({ display: 'block' });

            if (index == 0) {
                nodePrev.addClass('disabled');
            } else if (index == this.tabLength - 1) {
                nodeNext.addClass('disabled');
            } else {
                nodeNext.removeClass('disabled');
                nodePrev.removeClass('disabled');
            }
            if (this.get('scrollable')) {
                this.scrollToActiveTab(tab, val);
            }

            if(emit){
                this.emit("select", {
                    tab: tab,
                    prevTab: prevTab,
                    panel: panel,
                    prevPanel: prevPanel,
                    index: val,
                    prevIndex: prev
                });
            }
        },

        setOffset: function(target) {

            if (this.isInit) {
                this.isInit = false;
                this.iscroll.scrollTo(target, 0);
            } else {
                setTimeout(() => {
                    this.iscroll.scrollTo(target, 0, 500);
                }, 10);
            }

            this.offset = target;
        },

        scrollToActiveTab: function(activeTab, index) {
            const activeTabWH = this.itemWH;
            let direction = this.get('direction');
            let offset;

            if (direction == 'right') {
                offset = Math.min(0, -this.tabWrapWH + activeTabWH * (2 + index));
                offset = Math.max(-this.maxScrollWidth, offset);
            } else {
                if (index + 1 == this.tabLength) {
                    offset = Math.min(0, -(activeTabWH * (index - 1)));
                } else {
                    offset = Math.min(0, -(activeTabWH * (index)));
                }
                offset = Math.max(-this.maxScrollWidth, offset);
            }

            this.setOffset(offset);
        }
    });

    UpAct.TabView = SingleTabView;
});



// WEBPACK FOOTER //
// ./js/lib/tabview/index.js